/*{
  "id": 1,
  "plano_trabalho_id": 1,
  "etapa": 1,
  "fase": 2,
  "inicio": "2025-01-01",
  "fim": "2025-12-31",
  "unidade_medida": "dias",
  "quantidade": 100,
  "descricao": "Descrição de exemplo da meta.",
  "created_at": "2025-01-28T15:00:00Z",
  "updated_at": "2025-01-28T15:30:00Z"
}*/

import axios from "axios";

const API_URL = process.env.REACT_APP_API_KEY;

const postMetas = async (
  token: string,
  plano_trabalho_id: number,
  etapa: number,
  fase: number,
  inicio: string,
  fim: string,
  unidade_medida: string,
  quantidade: number,
  descricao: string
) => {
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  const response = await axios.post(
    `${API_URL}/metas`,
    {
      plano_trabalho_id,
      etapa,
      fase,
      inicio,
      fim,
      unidade_medida,
      quantidade,
      descricao,
    },
    config
  );
  return response.data;
};
export default postMetas;
